import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { PreviewContactDetailsComponent } from '../../../../shared/components/beneficiary/preview-contact-details/preview-contact-details.component';
import { PreviewBeneficiaryDetailsComponent } from '../../../../shared/components/beneficiary/preview-beneficiary-details/preview-beneficiary-details.component';
import { Card } from 'primeng/card';
import { Beneficjent } from '../../../../shared/models/beneficjent';
import { Button } from 'primeng/button';
import { Router } from '@angular/router';
import { PreviewAccountNumberComponent } from '../../../../shared/components/bank-account-number/preview-account-number/preview-account-number.component';
import { APP_PATHS } from '../../../../core/config/app-paths';
import { PreviewBeneficiaryAddressComponent } from '../preview-beneficiary-address/preview-beneficiary-address.component';
import { EmailVerifyInfo } from '../../../../shared/components/email-verify-info/email-verify-info';

@Component({
  selector: 'app-beneficiary-settings-beneficiary-data',
  imports: [
    PreviewContactDetailsComponent,
    PreviewBeneficiaryDetailsComponent,
    Card,
    Button,
    PreviewAccountNumberComponent,
    PreviewBeneficiaryAddressComponent,
    EmailVerifyInfo,
  ],
  templateUrl: './user-settings-beneficiary-data.component.html',
  styleUrl: './user-settings-beneficiary-data.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserSettingsBeneficiaryDataComponent {
  public beneficiary = input.required<Beneficjent>();
  #router = inject(Router);

  navigateToEditUser(): void {
    const url = `${APP_PATHS.userSettings.root}/${APP_PATHS.userSettings.editUser}`;
    this.#router.navigate([url]);
  }

  protected goToHomepage(): void {
    this.#router.navigate(['/']);
  }
}
